import React,{useState,useEffect} from 'react'
import axios from 'axios'
import { API_URL } from '../../Constant';
import { ToastContainer, toast } from 'react-toastify';
import messages from '../../assets/Messages.json'
import { useNavigate } from 'react-router-dom';
import {showAppLoading, generateYearRange,isNumeric, validateButtonASIBlock,getStatusFlagValue} from '../../Custom/Custom';
import asiTitle from '../../asi.json';

function BlockF({
    blockPageInfo,
    config,
    userInfoObject,
    blockInfo,
    accessAsiBlock,
    decode_token
}) {

    const normalizeBlockCData = (raw) => {
        // If backend already sends aggregated object, keep it.
        if (raw && !Array.isArray(raw) && typeof raw === 'object' && ('blockCItem1' in raw || 'blockCItem2' in raw || 'blockCItem34567' in raw)) {
            return raw;
        }

        // If backend sends Block C rows array, compute aggregates used in BlockF validations.
        const rows = Array.isArray(raw) ? raw : (Array.isArray(raw?.blockCData) ? raw.blockCData : []);

        const getRow = (assetCode) => rows.find((r) => String(r?.assetCode) === String(assetCode));
        const num = (v) => {
            const n = Number.parseFloat(v);
            return Number.isFinite(n) ? n : 0;
        };

        const row1 = getRow(1);
        // Treat item-1 value as col 13 if present; otherwise 0 (we still use "any entry" elsewhere)
        const blockCItem1 = num(row1?.closingAsOn711);

        const row2 = getRow(2);
        const blockCItem2 = num(row2?.closingAsOn711);

        // items 3+4+5+6+7 (col 13)
        const blockCItem34567 = [3, 4, 5, 6, 7].reduce((sum, code) => sum + num(getRow(code)?.closingAsOn711), 0);

        return {
            blockCItem1,
            blockCItem2,
            blockCItem34567,
            blockCData: rows, // keep raw rows for any extra checks
        };
    };

    const [itemData, setItemData] = useState({});
    const [blockFData, setBlockFData] = useState({});
    const [blockCData, setBlockCData] = useState({});
    const [blockDData, setBlockDData] = useState({});
    const navigate = useNavigate();
    const yearRange=generateYearRange(blockInfo.surveyYear);
    const [buttonStatus,setButtonStatus]=useState(''); 
    const statusUnitCode=localStorage.getItem('statusUnitCode')
    const roleCodes = decode_token?.id?.ROLE_CODE
        ? String(decode_token.id.ROLE_CODE)
              .split('|')
              .map((r) => String(r).trim())
              .filter(Boolean)
        : [];
    const isDivasiRole = roleCodes.includes('DIVASI');
    const isHqRole = roleCodes.includes('HQADM') || roleCodes.includes('HQASI');
    const currentStatusFlag = Array.isArray(blockFData) && blockFData.length > 0 ? blockFData[0]?.statusFlag : '';
    const isDivasiStatusFlagOne = isDivasiRole && String(currentStatusFlag ?? '').trim() === '1';
    const isHqStatusFlagThree = isHqRole && String(currentStatusFlag ?? '').trim() === '3';
    const isRestrictedRoleWithEmptyStatusFlag = (isDivasiRole || isHqRole) && String(currentStatusFlag ?? '').trim() === '';
    const isNextBlockAlreadyAccessible = (() => {
        const ids = JSON.parse(localStorage.getItem('blockIds') || '[]');
        return Array.isArray(ids) && ids.map(Number).includes(7);
    })();
 
    useEffect(()=>{
    
        const fetchBlockCForm = async (newObject) => {
            try {
                const resp = await axios.post(`${API_URL}api/asi/blockCForm`, newObject, config);
                const { data, status } = resp.data || {};
                if (status && data?.blockCData) {
                    setBlockCData(normalizeBlockCData(data.blockCData));
                    return true;
                }
            } catch (e) {
                console.error('BlockCForm fetch failed:', e);
            }
            return false;
        };

        const blockDData= async()=>{
        const newObject={
           dsl_no: blockInfo.dslNo,
           survey_year: blockInfo.surveyYear
         };
         showAppLoading(true)
         try {
           const response = await axios.post(`${API_URL}api/asi/blockFForm`, newObject, config);
          // const response = await axios.post(`https://updesdev.srmtechsol.com/api/asi/blockFForm`, newObject, config);
           const {data,status} = response.data;
              if (status) {
                 const responseBlockFData=data.blockFData;
                 setBlockFData(responseBlockFData)
                 const normalized = normalizeBlockCData(data.blockCData);
                 setBlockCData(normalized);
                 // Fallback: sometimes blockFForm doesn't return blockCData; fetch directly
                 const rows = Array.isArray(normalized) ? normalized : (Array.isArray(normalized?.blockCData) ? normalized.blockCData : []);
                 if (!rows || rows.length === 0) {
                    await fetchBlockCForm(newObject);
                 }
                 setBlockDData(data.blockDData)
                 const statusFlage = responseBlockFData[0].statusFlag;
                 const IsButtonStatus = await validateButtonASIBlock(decode_token, statusFlage);
                 const initialData = {};
                 responseBlockFData.forEach((item, index) => {
                        // SI No 2 (index 1) "Repair & maintenance of:" ke liye expenditure empty rakhna hai
                        const expenditureValue = (index === 1) ? '' : item.expenditure;
                        initialData[item.itemCode] = {
                        dslNo: item.dslNo,
                        surveyYear: item.surveyYear,
                        itemCode:item.itemCode,
                        expenditure: expenditureValue,
                        statusFlag: item.statusFlag,
                        ItemsName: item.ItemsName,
                        expenditureClass:"textBox_back_color_white"

                      };
                    });
                 
                setItemData(initialData);
                setButtonStatus(IsButtonStatus)
              }
         } catch (error) {
             console.error(error);
             toast.error('An error occurred while processing your request.', messages.COLOR_RED);
         } finally {
             showAppLoading(false);
         }
     
       }
       blockDData();
     
       },[])  

const handleOnChange = (itemCode, field, newValue) => {  
        // SI No 2 "Repair & maintenance of:" (index 1) ke liye value update nahi karna hai
        if (blockFData.length > 1 && blockFData[1]?.itemCode === itemCode && field === 'expenditure') {
            return; // SI No 2 ke liye value update nahi karega
        }
        
        if (!isNumeric(newValue)) {
            toast.error(messages.NUMERIC_MSG, messages.COLOR_RED);
            newValue = '';
        }
    
        setItemData(prevItemData => ({
            ...prevItemData,
            [itemCode]: {
                ...prevItemData[itemCode],
                [field]: newValue
            }
        }));
    }

const handleReset=()=>{
  const initialData = {};
   blockFData.forEach((item, index) => {
        // SI No 2 (index 1) "Repair & maintenance of:" ke liye expenditure empty rakhna hai
        const expenditureValue = (index === 1) ? '' : '';
        initialData[item.itemCode] = {
        dslNo: item.dslNo,
        surveyYear: item.surveyYear,
        itemCode:item.itemCode,
        expenditure: expenditureValue,
        statusFlag: item.statusFlag,
        ItemsName: item.ItemsName,
        expenditureClass:"textBox_back_color_white"
        };
   });
 setItemData(initialData);
   }
     
const handlePrevious=()=>{
    const confirmed = window.confirm("Have you saved your changes?");
    if (confirmed) {
        navigate("/BlockE")
    }
 }  
     
const handleNext= async()=>{
        // Next unlocked + Save disabled → skip save, sirf navigate (DIVASI/FACTO/DISASI/HQ sab)
        if (isNextBlockAlreadyAccessible && (buttonStatus || isDivasiStatusFlagOne || isHqStatusFlagThree || isRestrictedRoleWithEmptyStatusFlag)) {
            navigate("/BlockG");
            return;
        }
        // DIVASI + statusFlag=1: do not save, just navigate
        if (isDivasiStatusFlagOne) {
            navigate("/BlockG");
            return;
        }
        // HQADM/HQASI + statusFlag=3: do not save, just navigate
        if (isHqStatusFlagThree) {
            navigate("/BlockG");
            return;
        }
        const confirmed = window.confirm("Have you saved your changes?");
        if (!confirmed) return;
        if(statusUnitCode==='5'){
          const saveResult = await handleSaveData("SAVE");
          if (saveResult) {
             blockValidation()
             navigate("/BlockG")
          }
        }else{
          const saveResult = await handleSaveData("SAVE");
          if (saveResult) {
            blockValidation()
            navigate("/BlockG")
          }
        }
} 


 //All block validation Data
 const  blockValidation=async()=>{

  let  postData= {
     dsl_no: blockInfo.dslNo,
     survey_year: blockInfo.surveyYear
    }

 try {
    showAppLoading(true);
     const response = await axios.post(`${API_URL}api/asi/blockValidation`, postData, config);
     const {data,status} = response.data;
     const accessIds=data.allblockData
      if(accessIds.length>0){
          if(accessIds.length > [1,2,3,4,5,6,7].length){
            accessAsiBlock(accessIds)
          }else{
            accessAsiBlock([1,2,3,4,5,6,7])
          }
      }else{
         accessAsiBlock([1,2,3,4,5,6,7])
      }
      showAppLoading(false);
       return true;

     } catch (error) {
        console.error(error);
        toast.error('An error occurred while processing your request.', messages.COLOR_RED);
    } finally {
    
   }

}





const handleSaveData = async(buttonType) => {
       if (statusUnitCode !== '5' && !valForBlockF()) {
           return false;
         }

         let customItemCodes=[];
         const clickButtonStatusFlag = getStatusFlagValue(buttonType, userInfoObject.userLevel);
     
      for (let itemCode in itemData) {
          const customObject = {
                dslNo:  itemData[itemCode].dslNo,
                surveyYear: itemData[itemCode].surveyYear,
                itemCode:itemData[itemCode].itemCode,
                expenditure: handleValue(itemData[itemCode].expenditure),
                statusFlag: clickButtonStatusFlag
            };
            customItemCodes.push(customObject); 
       }

         const newObject={
           itemCodes:customItemCodes,
           payload:{
             dsl_no: blockInfo.dslNo,
             survey_year:  blockInfo.surveyYear,
             buttonType:buttonType
           }
         }
   
         showAppLoading(true);
        try {
          let data=newObject.itemCodes
          const is2024Year = blockInfo.surveyYear === 2024 || blockInfo.surveyYear === '2024';
          // For 2024-25, itemCode 1657 is "Interest paid" (old itemCode 80)
          // For old years, itemCode 80 is used
          const interestItemCode = is2024Year ? 1657 : 80;
          let dataStore=data.filter((elem)=>{
            return elem.itemCode == interestItemCode
          })
          let realValue=dataStore[0]
          localStorage.setItem("f11data",JSON.stringify(realValue))
           const response = await axios.post(`${API_URL}api/asi/blockFFormSaveToDB`, newObject, config);
           const {status,message} = response.data;
           if (status) {
            //  accessAsiBlock([1,2,3,4,5,6,7])
             blockValidation()
             toast.success(message, messages.COLOR_RED);
             return true;
           }
         } catch (error) {
             console.error(error);
             toast.error('An error occurred while processing your request.', messages.COLOR_RED);
         } finally {
             showAppLoading(false);
         }
       
     return false;
      

    }


const valForBlockF=()=>{
    const getBlockCItem1Value = () => {
        // Prefer aggregated value if API provides it, but ONLY if it's > 0.
        // (Requirement: if Block C row 1 has value in ANY column, skip this validation.)
        const direct = Number.parseFloat(blockCData?.blockCItem1);
        if (Number.isFinite(direct) && direct > 0) return direct;

        const getAssetCode = (row) =>
            row?.assetCode ?? row?.asset_code ?? row?.ASSET_CODE ?? row?.assetcode ?? row?.ASSETCODE;

        const pickFirst = (row, keys) => {
            for (const k of keys) {
                const v = row?.[k];
                if (v !== undefined && v !== null && v !== '') return v;
            }
            return undefined;
        };

        const computeAnyEntryValueForRow1 = (row1) => {
            if (!row1) return 0;
            // Treat "entry exists" if ANY numeric field in row 1 is > 0
            const fieldKeyGroups = [
                ['closingAsOn711', 'closing_as_on_711', 'CLOSING_AS_ON_711'], // col 13
                ['closingAsOn3456', 'closing_as_on_3456', 'CLOSING_AS_ON_3456'], // col 7
                ['openingAsOn38', 'opening_as_on_38', 'OPENING_AS_ON_38'],
                ['openingAsOn', 'opening_as_on', 'OPENING_AS_ON'],
                ['uptoYearBeginning', 'upto_year_beginning', 'UPTO_YEAR_BEGINNING'],
                ['providedDuringYear', 'provided_during_year', 'PROVIDED_DURING_YEAR'],
                ['uptoYearEnd', 'upto_year_end', 'UPTO_YEAR_END'],
                ['dueToRevaluation', 'due_to_revaluation', 'DUE_TO_REVALUATION'],
                ['actualAdditions', 'actual_additions', 'ACTUAL_ADDITIONS'],
                ['deductionAdjDuringYear', 'deduction_adj_during_year', 'DEDUCTION_ADJ_DURING_YEAR'],
                ['adjForSoldDiscardedDuringYear', 'adj_for_sold_discarded_during_year', 'ADJ_FOR_SOLD_DISCARDED_DURING_YEAR'],
            ];
            for (const keys of fieldKeyGroups) {
                const raw = pickFirst(row1, keys);
                const v = Number.parseFloat(raw);
                if (Number.isFinite(v) && v > 0) return v;
            }
            return 0;
        };

        // If blockCData is an array of Block C rows, use assetCode 1 (row 1)
        if (Array.isArray(blockCData)) {
            const row1 = blockCData.find((r) => String(getAssetCode(r)) === '1');
            return computeAnyEntryValueForRow1(row1);
        }

        // Sometimes nested as { blockCData: [...] }
        if (Array.isArray(blockCData?.blockCData)) {
            const row1 = blockCData.blockCData.find((r) => String(getAssetCode(r)) === '1');
            return computeAnyEntryValueForRow1(row1);
        }

        return 0;
    };

    const hasAnyValueForBlockCAssetCode = (assetCodeToCheck) => {
        const getAssetCode = (row) =>
            row?.assetCode ?? row?.asset_code ?? row?.ASSET_CODE ?? row?.assetcode ?? row?.ASSETCODE;

        const pickFirst = (row, keys) => {
            for (const k of keys) {
                const v = row?.[k];
                if (v !== undefined && v !== null && v !== '') return v;
            }
            return undefined;
        };

        const fieldKeyGroups = [
            ['closingAsOn711', 'closing_as_on_711', 'CLOSING_AS_ON_711'],
            ['closingAsOn3456', 'closing_as_on_3456', 'CLOSING_AS_ON_3456'],
            ['openingAsOn38', 'opening_as_on_38', 'OPENING_AS_ON_38'],
            ['openingAsOn', 'opening_as_on', 'OPENING_AS_ON'],
            ['uptoYearBeginning', 'upto_year_beginning', 'UPTO_YEAR_BEGINNING'],
            ['providedDuringYear', 'provided_during_year', 'PROVIDED_DURING_YEAR'],
            ['uptoYearEnd', 'upto_year_end', 'UPTO_YEAR_END'],
            ['dueToRevaluation', 'due_to_revaluation', 'DUE_TO_REVALUATION'],
            ['actualAdditions', 'actual_additions', 'ACTUAL_ADDITIONS'],
            ['deductionAdjDuringYear', 'deduction_adj_during_year', 'DEDUCTION_ADJ_DURING_YEAR'],
            ['adjForSoldDiscardedDuringYear', 'adj_for_sold_discarded_during_year', 'ADJ_FOR_SOLD_DISCARDED_DURING_YEAR'],
        ];

        const rows = Array.isArray(blockCData)
            ? blockCData
            : (Array.isArray(blockCData?.blockCData) ? blockCData.blockCData : []);

        const row = rows.find((r) => String(getAssetCode(r)) === String(assetCodeToCheck));
        if (!row) {
            // Debug: assetCode not found
            if (assetCodeToCheck === 140) {
                console.log('[BlockF] BlockC assetCode 140 row not found. Available assetCodes:', rows.map((r) => getAssetCode(r)));
            }
            return false;
        }

        // Debug: print raw row once per validation call
        if (assetCodeToCheck === 140) {
            console.log('[BlockF] BlockC assetCode 140 row:', row);
        }

        for (const keys of fieldKeyGroups) {
            const raw = pickFirst(row, keys);
            const v = Number.parseFloat(raw);
            if (Number.isFinite(v) && v > 0) {
                if (assetCodeToCheck === 140) {
                    console.log('[BlockF] BlockC assetCode 140 value found:', { keys, raw, v });
                }
                return true;
            }
        }
        return false;
    };

    let yearArray = [2017,2018,2019,2020,2021];
    const is2024Year = blockInfo.surveyYear === 2024 || blockInfo.surveyYear === '2024';
    let allObjectData=itemData
    let flagF=0;
    let allValidactionAlertBlockF="";
    let allSoftValidactionAlertBlockF="";
    let statusAlertF=0;
    // console.log("blockCData.blockCItem1",blockCData.blockCItem1);
    if(yearArray.includes(blockInfo.surveyYear)){
       // Old years logic (2017-2021)
       // const val0 = parseFloat(handleValue(allObjectData[67]?.expenditure));
        const val1 = parseFloat(handleValue(allObjectData[68]?.expenditure));
        const val2 = parseFloat(handleValue(allObjectData[71]?.expenditure));
        //# 1 
        const blockCItem2Value = parseFloat(blockCData?.blockCItem2) || 0;
        if(blockCItem2Value > 0 && val1 > 0) {
            if(val1 <= 50 * blockCItem2Value / 100){       
                 allObjectData[68].expenditureClass="textBox_back_color_white" 
            }else {
                allObjectData[68].expenditureClass="textBox_back_color_orange" 
                allSoftValidactionAlertBlockF= allSoftValidactionAlertBlockF + " Item 2(i) of Blk. F <= 50% of item 2, col. 13 of Blk. C. \n" ;
                statusAlertF=1;
              }
        } else {
            allObjectData[68].expenditureClass="textBox_back_color_white";
        }
          
        //# 2 
        const blockCItem34567Value = parseFloat(blockCData?.blockCItem34567) || 0;
        if(blockCItem34567Value > 0 && val2 > 0) {
            if(val2 <= 50 * blockCItem34567Value / 100){       
                  allObjectData[71].expenditureClass="textBox_back_color_white" 
           }else {
              allObjectData[71].expenditureClass="textBox_back_color_orange"
              allSoftValidactionAlertBlockF= allSoftValidactionAlertBlockF + " Item 2(ii) of  Blk. F <= 50% of (items 3+4+5+6+7), col. 13 of Blk. C. \n"
              statusAlertF=1;
           }
        } else {
            allObjectData[71].expenditureClass="textBox_back_color_white";
        }

        //# 3
        const val3 = parseFloat(handleValue(allObjectData[72]?.expenditure));
        // Item 9 (Rent paid for land on lease or royalties on mines, quarries and similar assets)
        const item9Row = Array.isArray(blockFData)
            ? blockFData.find((x) => String(x?.ItemsName || '').toLowerCase().includes('rent paid for land on lease'))
            : null;
        const item9ItemCode = item9Row?.itemCode ?? (blockFData.length > 10 ? blockFData[10]?.itemCode : null);
        const v9 = Number.parseFloat(handleValue(allObjectData[item9ItemCode]?.expenditure));
        const safeVal9 = Number.isFinite(v9) ? v9 : 0;

        // If Block C has value for assetCode 140, skip this soft validation completely
        const shouldSkipItem9 = hasAnyValueForBlockCAssetCode(140);
        const blockCItem1Value = shouldSkipItem9 ? 1 : getBlockCItem1Value();
        // Soft check: If there is no entry in Block C item 1, then Block F item 9 must be > 0
        if (blockCItem1Value <= 0) {
            if (safeVal9 > 0) {
                if (item9ItemCode) allObjectData[item9ItemCode].expenditureClass = "textBox_back_color_white";
            } else {
                if (item9ItemCode) allObjectData[item9ItemCode].expenditureClass = "textBox_back_color_orange";
                allSoftValidactionAlertBlockF = allSoftValidactionAlertBlockF + " If there is no entry in item 1 of Blk. C, then  item 9 of Blk. F >0. \n";
                statusAlertF = 1;
            }
        }

       //# 4
       const val10 = parseFloat(handleValue(allObjectData[79]?.expenditure));
        if(parseFloat(blockDData.diffCLOSING_OPENING_AMOUNT) > 0){
            if(val10 !== 0){
                allObjectData[79].expenditureClass="textBox_back_color_white"
            }else{
                allObjectData[79].expenditureClass="textBox_back_color_orange"
               allValidactionAlertBlockF= allValidactionAlertBlockF + " Value of item 10 (Interest Paid) of Block F must be filled. \n"
               flagF=1;
                statusAlertF=1;
            }
        }

         //# 5 - Item 12 validation removed as per requirement
        //# 6: Validation for Item 3 > sum of Item 12 + 13 + 14 + 15 (Item 11 is NOT included)
        // Find Item 12, 13, 14, 15 itemCodes from blockFData array dynamically
        let item12ItemCode = null;
        let item13ItemCode = null;
        let item14ItemCode = null;
        let item15ItemCode = null;
        if (blockFData.length > 0) {
          // Serial number 12 = index 13 (since serial = i - 1 for i > 3, so i = 13 means serial = 12)
          if (blockFData.length > 13) {
            item12ItemCode = blockFData[13].itemCode;
          }
          // Serial number 13 = index 14 (since serial = i - 1 for i > 3)
          if (blockFData.length > 14) {
            item13ItemCode = blockFData[14].itemCode;
          }
          // Serial number 14 = index 15
          if (blockFData.length > 15) {
            item14ItemCode = blockFData[15].itemCode;
          }
          // Serial number 15 = index 16
          if (blockFData.length > 16) {
            item15ItemCode = blockFData[16].itemCode;
          }
        }
        
        const val12 = parseFloat(handleValue(allObjectData[item12ItemCode]?.expenditure)) || 0;
        const val13 = parseFloat(handleValue(allObjectData[item13ItemCode]?.expenditure)) || 0;
        // const val14 = parseFloat(handleValue(allObjectData[item14ItemCode]?.expenditure)) || 0;
        // const val15 = parseFloat(handleValue(allObjectData[item15ItemCode]?.expenditure)) || 0;
        // const sumOfItems12To15 = val12 + val13 + val14 + val15;

        const sumOfItems12To15 = val12 + val13;
        
        if (val3 > sumOfItems12To15) {
          allObjectData[72].expenditureClass = "textBox_back_color_white";
        } else {
          allObjectData[72].expenditureClass = "textBox_back_color_red";
          allValidactionAlertBlockF = allValidactionAlertBlockF + " Item 3 must be greater than the sum of Item 12 + 13. \n";
          flagF = 1;
          statusAlertF = 1;
          return false; // stop duplicate validation firing
        }
    } else if (is2024Year) {
       // 2024-2025 logic
       // Item 2(i): itemCode 1648 (index 2) - "(i) Buildings and other construction"
       const val1 = parseFloat(handleValue(allObjectData[1648]?.expenditure));
       // Item 2(ii): itemCode 1649 (index 3) - "(ii) Other fixed assets"
       const val2 = parseFloat(handleValue(allObjectData[1649]?.expenditure));
       
       //# 1 
       const blockCItem2Value = parseFloat(blockCData?.blockCItem2) || 0;
       if(blockCItem2Value > 0 && val1 > 0) {
           if(val1 <= 50 * blockCItem2Value / 100){       
                allObjectData[1648].expenditureClass="textBox_back_color_white" 
           }else {
               allObjectData[1648].expenditureClass="textBox_back_color_orange" 
               allSoftValidactionAlertBlockF= allSoftValidactionAlertBlockF + " Item 2(i) of Blk. F <= 50% of item 2, col. 13 of Blk. C. \n" ;
               statusAlertF=1;
             }
       } else {
           allObjectData[1648].expenditureClass="textBox_back_color_white";
       }
         
       //# 2 
       const blockCItem34567Value = parseFloat(blockCData?.blockCItem34567) || 0;
       if(blockCItem34567Value > 0 && val2 > 0) {
           if(val2 <= 50 * blockCItem34567Value / 100){       
                 allObjectData[1649].expenditureClass="textBox_back_color_white" 
          }else {
             allObjectData[1649].expenditureClass="textBox_back_color_orange"
             allSoftValidactionAlertBlockF= allSoftValidactionAlertBlockF + " Item 2(ii) of  Blk. F <= 50% of (items 3+4+5+6+7), col. 13 of Blk. C. \n"
             statusAlertF=1;
          }
       } else {
           allObjectData[1649].expenditureClass="textBox_back_color_white";
       }

       //# 3
       // Item 3: itemCode 1650 (index 4) - "Operating expenses"
       const val3 = parseFloat(handleValue(allObjectData[1650]?.expenditure));
       // Item 9 (Rent paid for land on lease or royalties on mines, quarries and similar assets)
       const item9Row = Array.isArray(blockFData)
           ? blockFData.find((x) => String(x?.ItemsName || '').toLowerCase().includes('rent paid for land on lease'))
           : null;
       const item9ItemCode = item9Row?.itemCode ?? (blockFData.length > 10 ? blockFData[10]?.itemCode : null);
       const v9 = Number.parseFloat(handleValue(allObjectData[item9ItemCode]?.expenditure));
       const safeVal9 = Number.isFinite(v9) ? v9 : 0;

       // If Block C has value for assetCode 140, skip this soft validation completely
       const shouldSkipItem9 = hasAnyValueForBlockCAssetCode(140);
       const blockCItem1Value = shouldSkipItem9 ? 1 : getBlockCItem1Value();
       if (blockCItem1Value <= 0) {
           if (safeVal9 > 0) {
               if (item9ItemCode) allObjectData[item9ItemCode].expenditureClass = "textBox_back_color_white";
           } else {
               if (item9ItemCode) allObjectData[item9ItemCode].expenditureClass = "textBox_back_color_orange";
               allSoftValidactionAlertBlockF = allSoftValidactionAlertBlockF + " If there is no entry in item 1 of Blk. C, then  item 9 of Blk. F >0. \n";
               statusAlertF = 1;
           }
       }

      //# 4
      // Item 10: itemCode 1657 (index 11) - "Interest paid"
      const val10 = parseFloat(handleValue(allObjectData[1657]?.expenditure));
       if(parseFloat(blockDData.diffCLOSING_OPENING_AMOUNT) > 0){
           if(val10 !== 0){
               allObjectData[1657].expenditureClass="textBox_back_color_white"
           }else{
               allObjectData[1657].expenditureClass="textBox_back_color_orange"
              allValidactionAlertBlockF= allValidactionAlertBlockF + " Value of item 10 (Interest Paid) of Block F must be filled. \n"
              flagF=1;
               statusAlertF=1;
           }
       }

        //# 5 - Item 12 validation removed as per requirement
       //# 6: Validation for Item 3 > sum of Item 12 + 13 + 14 + 15 (Item 11 is NOT included)
       // Find Item 12, 13, 14, 15 itemCodes from blockFData array dynamically
       let item12ItemCode = null;
       let item13ItemCode = null;
       let item14ItemCode = null;
       let item15ItemCode = null;
       if (blockFData.length > 0) {
         // Serial number 12 = index 13 (since serial = i - 1 for i > 3, so i = 13 means serial = 12)
         if (blockFData.length > 13) {
           item12ItemCode = blockFData[13].itemCode;
         }
         // Serial number 13 = index 14 (since serial = i - 1 for i > 3)
         if (blockFData.length > 14) {
           item13ItemCode = blockFData[14].itemCode;
         }
         // Serial number 14 = index 15
         if (blockFData.length > 15) {
           item14ItemCode = blockFData[15].itemCode;
         }
         // Serial number 15 = index 16
         if (blockFData.length > 16) {
           item15ItemCode = blockFData[16].itemCode;
         }
       }
       
       const val12 = parseFloat(handleValue(allObjectData[item12ItemCode]?.expenditure)) || 0;
       const val13 = parseFloat(handleValue(allObjectData[item13ItemCode]?.expenditure)) || 0;
      //  const val14 = parseFloat(handleValue(allObjectData[item14ItemCode]?.expenditure)) || 0;
      //  const val15 = parseFloat(handleValue(allObjectData[item15ItemCode]?.expenditure)) || 0;

      //  const sumOfItems12To15 = val12 + val13 + val14 + val15;

      const sumOfItems12To15 = val12 + val13 
      
       
       if (val3 > sumOfItems12To15) {
         allObjectData[1650].expenditureClass = "textBox_back_color_white";
       } else {
         allObjectData[1650].expenditureClass = "textBox_back_color_red";
         allValidactionAlertBlockF = allValidactionAlertBlockF + " Item 3 must be greater than the sum of Item 12 + 13 \n";
         flagF = 1;
         statusAlertF = 1;
       }
    }

    // Common validation logic for both old and new years
    // let valtotal = val0+val1+val2+val3+val4+val5+val6;

    if (statusAlertF === 1 && allSoftValidactionAlertBlockF.length > 0) {
        allSoftValidactionAlertBlockF = allSoftValidactionAlertBlockF+" \nFor change any Values Click OK."
        const clicked = window.confirm(allSoftValidactionAlertBlockF);                    
        allSoftValidactionAlertBlockF="";
        statusAlertF = 0;
        // Soft check behavior: OK = continue, Cancel = stop
        if(!clicked){
            return false;
        }
    }

    if(flagF===1)
    {
        if(statusAlertF===1){
            alert(`${allValidactionAlertBlockF}\nTotal does not match. Please check highlighted fields.`);
            statusAlertF=0;
        }else{
            alert('Total does not match. Please check highlighted fields');
        }
        
        flagF=0;
        return false;
    }
    handleValidationAlert(allObjectData)
    return true;
}

const handleValidationAlert = (allObjectData) => { 
    const initialData = {};
    for (let itemCode in allObjectData) {
      const item = allObjectData[itemCode];
      initialData[itemCode] = {
        dslNo: item.dslNo,
        surveyYear: item.surveyYear,
        itemCode:item.itemCode,
        expenditure: item.expenditure,
        statusFlag: item.statusFlag,
        ItemsName: item.ItemsName,
        expenditureClass:item.expenditureClass
      };
     
    };   
    setItemData(initialData);
  }
  
const handleValue = (value) => {
    return (value !== "" && value !== null && value !== undefined) ? value : 0;
  };
  const storedLanguage = localStorage.getItem('language');
  return (
    <div className="card-body">
    {/* <ToastContainer/> */}
         <h4 className="page_heading border-bottom-0">
         <div dangerouslySetInnerHTML={{ __html: storedLanguage === 'hi' ? asiTitle.hi.BLOCK_F_TITLE : asiTitle.en.BLOCK_F_TITLE }} />
          </h4>
          <div className="row">
                    <div className="col-12">
                        <h6 className="fw-semibold">
                        DSL No.: <span className="fw-normal me-5">{blockInfo.dslNo}</span> 
                        Survey Year: <span className="fw-normal">{yearRange}</span></h6>
                        <div className="table-responsive asi_block_table">
                            <table cellPadding="0" cellSpacing="0" id="" className="table table-bordered block_c_table">                                
                                <thead>
                                    <tr>
                                    <th>{storedLanguage === 'hi' ? asiTitle.hi.SL_NO : asiTitle.en.SL_NO}</th>
                                    <th>{storedLanguage === 'hi' ? asiTitle.hi.ITEMS : asiTitle.en.ITEMS}</th>
                                    <th>{storedLanguage === 'hi' ? asiTitle.hi.EXPENDITURE : asiTitle.en.EXPENDITURE}</th>
                                    </tr>
                                    <tr>
                                        <th>1</th>
                                        <th>2</th>
                                        <th>3</th>
                                    </tr>
                                    </thead>
                                        <tbody>
                                        {blockFData.length > 0 && blockFData.map((item,i)=>{
                                              // Serial number logic: 
                                              // Index 0: SI No. 1
                                              // Index 1: SI No. 2 (Repair & maintenance of: - disabled)
                                              // Index 2: No SI No. (sub-item "(i) Buildings and other construction")
                                              // Index 3: No SI No. (sub-item "(ii) Other fixed assets")
                                              // Index 4: SI No. 3 (Operating expenses)
                                              // Index 5+: Continue with SI No. 4, 5, etc.
                                              let currentSrNo = null;
                                              if (i === 0) {
                                                 currentSrNo = 1;
                                              } else if (i === 1) {
                                                 currentSrNo = 2;
                                              } else if (i === 2 || i === 3) {
                                                 // Skip serial number for sub-items (index 2 and 3)
                                                 currentSrNo = null;
                                              } else {
                                                 // For indices > 3, serial = i - 1 (since we skipped 2 sub-items)
                                                 currentSrNo = i - 1;
                                              }

                                            return  (
                                                     <tr key={i}>
                                                        <td>
                                                          {currentSrNo !== null && currentSrNo}
                                                        </td>

                                                        <td>
                                                         {i===1 ?  
                                                         <b>{item.ItemsName}</b>
                                                          : 
                                                          item.ItemsName
                                                        } 
                                                        </td>
                                                        <td className={itemData[item.itemCode]?.expenditureClass || 'textBox_back_color_white'}>
                                                            <input 
                                                            type="text" 
                                                            className="form-control"
                                                            id={`expenditure${i}`}
                                                            name={`expenditure${i}`}
                                                            value={i === 1 ? '' : (itemData[item.itemCode]?.expenditure ?? '')} // SI No 2 (index 1) ke liye value empty
                                                            disabled={i === 1} // Disable "Repair & maintenance of:" field (index 1)
                                                            onChange={e => handleOnChange(item.itemCode, 'expenditure', e.target.value)} 
                                                            
                                                            />
                                                        </td>
                                                    </tr> 
                                            )

                                        })}
                                    </tbody>
                                </table>
                        </div>
                    </div>
                  
                </div>
                <div className="row">
                <div className="col-12">
                  <hr/>
                </div>
            
                  <div className="col-lg-8 text-center text-lg-start mb-3 mb-lg-0">
                        <button 
                        type="submit" 
                        className="btn btn_orange me-1"
                        onClick={()=>{ window.print()}}
                        >Print 
                        <i className="fa fa-print ms-1"></i>
                        </button>

                        <button 
                        type="button" 
                        className="btn btn_orange me-1"
                        onClick={(e)=>{handleSaveData("SAVE")}}
                        disabled={buttonStatus || isDivasiStatusFlagOne || isHqStatusFlagThree || isRestrictedRoleWithEmptyStatusFlag}
                        >
                        Save
                        </button>

                        <button 
                        type="reset" 
                        className="btn btn_orange me-1"
                        onClick={handleReset}
                        >
                        Reset
                        </button>

                        <button 
                        type="button" 
                        className="btn btn_orange"
                        onClick={(e)=>( navigate("/dashboard"))}
                        >
                        Cancel
                     </button>

                  </div>
               
                  <div className="col-lg-4 text-center text-lg-end">
                     <button 
                     type="button" 
                     className="btn btn_orange mx-1"
                     onClick={handlePrevious}
                     >
                     <i className="fa fa-angle-left me-1"></i> 
                     Previous
                  </button>

                     <button 
                     type="button" 
                     className="btn btn_orange mx-1"
                     onClick={handleNext}
                     disabled={isNextBlockAlreadyAccessible ? false : (isRestrictedRoleWithEmptyStatusFlag ? true : ((isDivasiStatusFlagOne || isHqStatusFlagThree) ? false : buttonStatus))}
                     >
                     Next
                     <i className="fa fa-angle-right ms-1"></i>
                  </button>

                  </div>
                        
               </div>

          </div>
  )
}

export default BlockF